import { RouteItem } from '@eastcoal/router/types/route'

import { YX_SALE_PLAN_LIST_PAGE_PATH } from './constants/path'
import {
  YX_SALE_PLAN_AUCTION_MANAGE_ACTION_UUID,
  YX_SALE_PLAN_LIST_PAGE_UUID
} from './constants/uuid'

export const yXSalePlanRoute: RouteItem = {
  title: '销售计划',
  hideChildrenInMenu: true,
  uuid: YX_SALE_PLAN_LIST_PAGE_UUID,
  children: [
    {
      title: '销售列表',
      path: YX_SALE_PLAN_LIST_PAGE_PATH,
      Component: () => import('./List')
    },
    {
      title: '关联场次',
      uuid: YX_SALE_PLAN_AUCTION_MANAGE_ACTION_UUID
    }
  ]
}
